// extracted by mini-css-extract-plugin
export var button = "protected-file-module--button--0icDh";
export var loading = "protected-file-module--loading--hNso0";